export default "__VITE_ASSET__CQlWzL9F__"